__turbopack_context__.v({
  "block": "skeleton-module__Cuawza__block",
  "line": "skeleton-module__Cuawza__line",
  "skeleton": "skeleton-module__Cuawza__skeleton",
  "skeleton-pulse": "skeleton-module__Cuawza__skeleton-pulse",
});
